import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMedia, removeMedia, updateMedia } from 'slice/mediaSlice';
import AdminTable from 'common/AdminTable';
import { toast } from 'react-toastify';

const List = () => {
  const dispatch = useDispatch();
  // const { data: mediaList, loading } = useSelector((state) => state.media);
  const { list: mediaList, loading } = useSelector((state) => state.media);

  const [showModal, setShowModal] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    url: ''
  });

  useEffect(() => {
    dispatch(getMedia());
  }, [dispatch]);

  const handleEditClick = (item) => {
    setSelectedMedia(item);
    setFormData({
      title: item.title || '',
      url: item.url || ''
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedMedia(null);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveChanges = () => {
    const updatedData = new FormData();
    updatedData.append('title', formData.title);
    updatedData.append('url', formData.url);

    dispatch(updateMedia({ id: selectedMedia.id, data: updatedData }));
    toast.success('Video updated successfully');
    dispatch(getMedia());
    closeModal();
  };

  const handleRemove = (id) => {
    dispatch(removeMedia(id));
    toast.success('Video removed successfully');
  };

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Title', accessor: 'title' },
    {
      Header: 'URL',
      accessor: 'url',
      Cell: ({ value }) => (
        <a href={value} target="_blank" rel="noreferrer">
          {value}
        </a>
      )
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button className="btn btn-danger mx-1" onClick={() => handleRemove(row.original.id)}>
            Remove
          </button>
          <button className="btn btn-primary mx-1" onClick={() => handleEditClick(row.original)}>
            Edit
          </button>
        </>
      )
    }
  ];

  return (
    <>
      <div className="container-fluid mt-5">
        <div className="mainheadig mx-4">
          <h4 className="text-white font-weight-bold">Video List</h4>
        </div>

        <AdminTable tableHeaders={tableHeaders} tableData={mediaList || []} />

        {loading && <p className="text-white mx-4 mt-2">Updating video...</p>}

        {!loading && mediaList?.length === 0 && <p className="text-white mx-4">No videos found.</p>}
      </div>

      {/* 🔥 EDIT MODAL (SAME UI STYLE AS TEACHER/HIGHLIGHT) */}
      {showModal && selectedMedia && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Video</h5>
                <button type="button" className="close" onClick={closeModal}>
                  <span>&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="mb-2">
                  <label htmlFor="title" className="form-label">
                    Title
                  </label>
                  <input id="title" type="text" name="title" value={formData.title} onChange={handleFormChange} className="form-control" />
                </div>

                <div className="mb-2">
                  <label htmlFor="url" className="form-label">
                    Video URL
                  </label>
                  <input id="url" type="text" name="url" value={formData.url} onChange={handleFormChange} className="form-control" />
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSaveChanges}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default List;
